import React, { useRef } from "react";
import {FaInstagram, FaLinkedin } from "react-icons/fa";
import {
  Container,
  Form,
  FormButton,
  FormContent,
  FormH1,
  FormH2,
  FormInput,
  FormLabel,
  FormWrap,
  Info,
  FormMessage,
  Text,
  SocialIcons,
  SocialIconsLink,
} from "./ContactusElements";
import emailjs from '@emailjs/browser';

const ContactUs = () => {

  const form = useRef();

  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_0axm8ss",
        "template_durxl2p",
        form.current,
        "-q9QrWBpp1qKpFDZE"
      )
      .then(
        (result) => {
          console.log(result.text);
          console.log("sent");
        },
        (error) => {
          console.log(error.text);
          console.log(" not sent");
        }
      );
        e.target.reset();
  }

  return (
    <>
      <Container>
        <FormWrap>
          <FormContent>
            <Info>
              <FormH1> Contact Info </FormH1>
              <Text>
                We are always happy to help and welcome any questions or
                feedback you may have. Feel free to connect with us on social
                media.
              </Text>
              <p></p>
              <Text>Address: 4th Floor, Silverstream House, 45 Fitzroy Street, Fitzrovia, London, W1T 6EB</Text>

              <p></p>
              <Text>Email: ray@structuralconnections.co.uk</Text>

              <SocialIcons>

                <SocialIconsLink
                  href="https://www.instagram.com/structuralconnections/"
                  target="_blank"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </SocialIconsLink>

                <SocialIconsLink
                  href="https://www.linkedin.com/company/structural-connections-ltd/"
                  target="_blank"
                  aria-label="Linkedin"
                >
                  <FaLinkedin />
                </SocialIconsLink>
              </SocialIcons>
            </Info>

            <Form>
            <form ref={form} onSubmit={sendEmail}>
                <FormH2> Get In Touch</FormH2>
                <FormLabel>Name</FormLabel>
                <FormInput type="text" name="name" /> 
                {'\n'}
                <FormLabel>Email</FormLabel>{'\n'}
                <FormInput type="email" name="email" />  
                <FormLabel>Subject</FormLabel>
                <FormInput type="subject" name="subject" /> 
                <FormLabel>Message</FormLabel>
                <FormMessage name="message" /> 
                <FormButton type="submit" value="Send" /> 
                </form>
                </Form> 
          </FormContent>
        </FormWrap>
      </Container>
    </>
  );
};

export default ContactUs;
